export const THAI_ONLY = /^[\p{Script=Thai} ]+$/u;

export const DIGITS_ONLY = /^\d+$/;

export const ASCII_DIGITS_ONLY = /^[0-9]+$/;

export const TH_MOBILE_STRICT = /^0[689][0-9]{8}$/;

export const TH_MOBILE_NO_SAME = /^(?!([0-9])\1{9})0[689][0-9]{8}$/;

export const toIsoDate = (raw?: string) => {
  if (!raw) return '';
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
  const cleaned = raw.replace(/\./g, ''); // "Jun." -> "Jun"
  const d = new Date(cleaned);
  if (isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const EMAIL_FORMAT = /^(?!.*\.\.)(?!\.)(?!.*\.$)[A-Za-z0-9_%+-]+(?:\.[A-Za-z0-9_%+-]+)*@[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?(?:\.[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)+$/;
